// eslint-disable-next-line no-undef
__webpack_public_path__ = '/';
